// responsive images lazyloading
import $ from 'jquery'
import 'lazysizes/plugins/object-fit/ls.object-fit'
import 'lazysizes/plugins/parent-fit/ls.parent-fit'
import 'lazysizes/plugins/rias/ls.rias'
import 'lazysizes/plugins/bgset/ls.bgset'
import 'lazysizes'
import 'lazysizes/plugins/respimg/ls.respimg'

// internal modules
import './modules/cart'
import './modules/search'
import './modules/menu'
import './modules/announcement'
import './modules/qty-select'
import './modules/option-switcher'
import './modules/slider'
import './modules/tabs'
import './modules/collection'
import './modules/giftcard'
import './modules/product-card'
import './modules/customer-addresses'
import './modules/dialogs'

window.theme = window.theme || {}
window.jQuery = window.$ = $
